import * as APPCONFIG from "../../src/config/app-config";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const FreezeWallet = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/freeze-toggle`,
    data: form, // example: { userId: 123 }
    headers: Http.AUTH_HEADERS(),
  });
};

export const updateKyc = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/kyc/status`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const moneyRequestList = () => {
  return auth({
    method: "get",
    url: `${APPCONFIG.API_URL}auth/request/list`,
    headers: Http.AUTH_HEADERS(),
  });
};

export const createMoneyRequest = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/request/create`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const cancelMoneyRequest = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/request/cancel`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const AdjustWalletTransaction = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/adjust-balance`, // <-- Adjust endpoint based on your backend
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const QrGenerate = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/generate`, // <-- Adjust endpoint based on your backend
    headers: Http.AUTH_HEADERS(),
    data: JSON.stringify(form),
  });
};

export const toggleQrType = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/toggleQrType`,
    data: form, // example: { userId: 123 }
    headers: Http.AUTH_HEADERS(),
  });
};

export const topUpWallet = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/top-up`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  }).then((res) => res.data);
};

export const sendRemainder = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/request/sendRemainder`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  }).then((res) => res.data);
};

export const createWallet = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/create`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  }).then((res) => res.data);
};

export const activePrimary = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/wallet/activePrimary`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  }).then((res) => res.data);
};
